import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExpandMore = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" })
});
export default SvgExpandMore;
